/**
 * The known messages that can be sent and handled by this app.
 */
export class PostMessages {
}

// Notify parent (e.g., Director) that MegaScreen is now ready to receive post messages
PostMessages.MEGASCREEN_INIT = 'MEGASCREEN_INIT';

// Notify parent (e.g., Director) that MegaScreen's boot process has completed (which includes
// loading all content and themes). MegaScreen is now ready to display content.
PostMessages.MEGASCREEN_BOOT_COMPLETE = 'MEGASCREEN_BOOT_COMPLETE';

// The DISABLE_MRTS_ENDPOINT_MONITORING message allows MegaScreen's MRTS-endpoint monitoring to
// be turned off externally, as is required by Director. Director disables MegaScreen's
// MRTS-endpoint monitoring so that changes to the endpoint can be managed centrally, and
// Director's and MegaScreen's MRTS connections can be kept in sync.
PostMessages.DISABLE_MRTS_ENDPOINT_MONITORING = 'DISABLE_MRTS_ENDPOINT_MONITORING';

// An external request to show or hide MegaScreen's debug panel.
PostMessages.TOGGLE_DEBUGGER = 'TOGGLE_DEBUGGER';

// An external request to hide MegaScreen's debug panel.
PostMessages.CLOSE_DEBUGGER = 'CLOSE_DEBUGGER';

// An external request to advance the current runstate. Arguments are:
// stateName
// sceneID
PostMessages.SET_STATE = 'SET_STATE';

// Notify parent that debug panel closed
PostMessages.DEBUGGER_CLOSED = 'DEBUGGER_CLOSED';

// Notify parent that debug panel opened
PostMessages.DEBUGGER_OPENED = 'DEBUGGER_OPENED';

// Notify parent that an attempt to autoplay a video with sound failed
PostMessages.UNMUTED_AUTOPLAY_REJECTED = 'UNMUTED_AUTOPLAY_REJECTED';

// Notify parent that MegaScreen muted sound
PostMessages.MEGASCREEN_MUTED = 'MEGASCREEN_MUTED';

// Instructs MegaScreen to toggle all sound on or off
PostMessages.TOGGLE_MUTE = 'TOGGLE_MUTE';

// Notify parent that MegaScreen unmuted sound
PostMessages.MEGASCREEN_UNMUTED = 'MEGASCREEN_UNMUTED';

// Notify parent that MegaScreen could not find the ThemeSet specified for the current state,
// most likely because the ThemeSet is not available in the current project.
PostMessages.THEMESET_NOT_FOUND = 'THEMESET_NOT_FOUND';

// Notify parent that the Theme specified for the current state is not valid, most likely because
// the Theme files were never uploaded, were deleted, or could not be parsed.
PostMessages.THEME_INVALID = 'THEME_INVALID';

// Notify parent that an asset (such as a video or an image) has started to download.
PostMessages.ASSET_DOWNLOAD_START = 'ASSET_DOWNLOAD_START';

// Notify parent that an asset finished downloading (or failed to download).
PostMessages.ASSET_DOWNLOAD_END = 'ASSET_DOWNLOAD_END';
